import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './classes/BaseService';
import { Config } from './classes/Config';

@Injectable()
export class HealthService extends BaseService{

  constructor(protected http: HttpClient) {
    super(http);
  }

  getWebsiteHealth() {
    let url = Config.websiteHealthServerUrl + "../health/websiteHealth.php";
    return this.get(url);
  }

}
